import { ReactElement } from 'react';
import ButtonLoader from '../loaders/button-loader.component';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'lg';
  variant?:
    | 'override'
    | 'solid'
    | 'outline'
    | 'outline-white'
    | 'outline-gray'
    | 'ghost'
    | 'link'
    | 'white'
    | 'filter';
  children: React.ReactNode;
  type?: 'submit' | 'reset' | 'button';
  className?: string;
  iconStart?: ReactElement;
  iconEnd?: ReactElement;
  isLoading?: boolean;
}

const Button = ({
  variant = 'solid',
  size = 'lg',
  children,
  type,
  className,
  isLoading,
  iconStart,
  iconEnd,
  ...props
}: ButtonProps) => {
  let styles = '';
  switch (variant) {
    case 'override':
      break;
    case 'solid':
      styles =
        'border-transparent bg-main text-white hover:bg-main-hover hover:bg-main-hover hover:text-white';
      break;
    case 'outline':
      styles = 'border-main text-main hover:bg-main-hover hover:text-white';
      break;
    case 'outline-gray':
      styles =
        'border border-gray-200 text-main hover:bg-main-hover hover:text-white';
      break;
    case 'outline-white':
      styles =
        'border-white text-white hover:bg-white hover:text-main-hover hover:border-white';
      break;
    case 'ghost':
      styles =
        'border-transparent text-main hover:bg-main-hover hover:text-white';
      break;
    case 'link':
      styles = 'border-transparent text-main hover:text-main-hover';
      break;
    case 'white':
      styles =
        'font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-xs hover:bg-gray-50';
      break;
    case 'filter':
      styles =
        'border-transparent bg-indigo-100 text-indigo-800 hover:bg-indigo-500 hover:text-white';
      break;
    default:
      break;
  }

  const sizeStyles = size === 'sm' ? 'py-2 px-3 text-xs' : 'py-3 px-4 text-sm';

  return (
    <button
      disabled={isLoading}
      {...props}
      type={`${type ?? 'button'}`}
      className={`transition-all inline-flex justify-center items-center ${iconStart || iconEnd ? 'gap-x-2' : ''} font-semibold rounded-lg border disabled:opacity-50 disabled:pointer-events-none ${sizeStyles} ${styles} ${className}`}
    >
      {isLoading && <ButtonLoader />}
      {!isLoading && iconStart && <span>{iconStart}</span>}
      <span className="flex items-center">
        {isLoading ? 'Loading...' : children}
      </span>
      {!isLoading && iconEnd && <span>{iconEnd}</span>}
    </button>
  );
};

export default Button;
